import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";

import { WORKFLOW_FEED_TYPES, FB_COLLECTION_PATH } from "./postActionTypes";

export async function fx_FB_WerkerFeedUpdateAll(
  fromUID: string,
  schedulerUID: string,
  jobID: string,
  additionalDetails: any
) {
  const userRef = collection(db, FB_COLLECTION_PATH.Users);
  await addDoc(collection(userRef, fromUID, "jobFeedUpdatePending"), {
    JobInfo: {
      fromUID,
      schedulerUID,
      jobID,
      additionalDetails: {
        action: additionalDetails?.action ?? WORKFLOW_FEED_TYPES.Filled,
      },
    },
  });
  return { status: "sent" };
}

